/*
 * Shirt offer nudge — Convert experiment (Control / V1 / V2).
 * Markup + config: snippets/ta-shirt-nudge.liquid. Settings: "Shirt offer nudge (Convert test)".
 *
 * Variation (set from Convert variation JS, in ALL arms including Control) — one line:
 *   window.AB_CART_NUDGE = 'v1';   // 'v1' | 'v2' | 'off' (original / control)
 *   The value is remembered for the browser tab (sessionStorage), so it stays on every page
 *   until changed; closing the tab forgets it and the original is shown again.
 *
 *   State        off       v1        v2
 *   0 shirts     -         -         reminder ("Shirt offer: 4 for £160, only £40 per shirt. Save £116 →")
 *   1-3 shirts   -         nudge     nudge   ("Add 3 more to unlock 4 for £160 and save £116")
 *   4+ shirts    -         -       -
 *
 * Both sit right after <ul class="subtotlalist subtotlalist_top"> (the subtotal) in the side cart.
 *
 * Shirts are counted by quantity, for products in the configured collections
 * (must match the Discounty shirt offer). The experiment is activated in Convert the
 * first time the side cart opens on a page, never on page load.
 * Debug: ?ta_nudge_debug=1  ·  Preview: ?ta_nudge=v1 | v2 | off
 */
(function () {
  'use strict';

  if (window.TAShirtNudge && window.TAShirtNudge.loaded) return;

  var configEl = document.getElementById('ta-shirt-nudge-config');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var VARIATIONS = ['control', 'v1', 'v2'];
  var DRAWER_SELECTOR = '.tos_warning.cart_content';
  var DRAWER_OPEN_CLASS = 'fadeInd';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var QA_KEY = 'ta_nudge_qa';
  var FIRED_KEY = 'ta_nudge_fired';
  var AB_KEY = 'ta_nudge_ab'; // last window.AB_CART_NUDGE value, kept for this tab only
  var IDS_KEY = 'ta_nudge_ids';
  var IDS_TTL = 30 * 60 * 1000;

  var collections = (cfg.collections || []).filter(Boolean);
  var bundleQty = parseInt(cfg.qty, 10) || 4;
  var shirtIds = {};
  (cfg.seedProductIds || []).filter(Boolean).forEach(function (id) { shirtIds[String(id)] = true; });

  var state = {
    variation: null,
    activated: false,
    cart: null,
    shirtCount: null,
    itemCount: 0,
    addedWhileOpen: false,
  };

  var debug = /[?&]ta_nudge_debug=1/.test(location.search);
  function log() {
    if (debug && window.console) console.log.apply(console, ['[ta-shirt-nudge]'].concat([].slice.call(arguments)));
  }

  /* ---------- storage helpers (never throw) ---------- */

  function sessionGet(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function sessionSet(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked */ }
  }
  function sessionRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) { /* storage blocked */ }
  }
  /* ---------- Convert ---------- */

  function convertPush(command) {
    window._conv_q = window._conv_q || [];
    window._conv_q.push(command);
    log('convert', command);
  }

  function activateExperiment() {
    if (state.activated) return;
    state.activated = true;
    if (cfg.locationId) {
      convertPush({ what: 'triggerLocation', params: { locationId: String(cfg.locationId) } });
    } else if (cfg.experimentId) {
      convertPush(['executeExperiment', String(cfg.experimentId)]);
    }
    detectVariationFromConvert();
  }

  // Each goal fires once per session; Convert reports it per variation, so the same
  // "Shown" goal in an arm that hides it (Control, or V1 for the reminder) is the "would have shown" comparison group.
  function triggerGoal(key, once) {
    var goalId = cfg.goals && cfg.goals[key];
    if (!goalId) return;
    if (sessionGet(QA_KEY)) {
      log('goal (QA preview, not sent)', key);
      return;
    }
    if (once) {
      var fired = sessionGet(FIRED_KEY) || {};
      if (fired[key]) return;
      fired[key] = 1;
      sessionSet(FIRED_KEY, fired);
    }
    if (cfg.convertApi === 'legacy') {
      convertPush(['triggerConversion', String(goalId)]);
    } else {
      convertPush({ what: 'triggerConversion', params: { goalId: String(goalId) } });
    }
    document.dispatchEvent(new CustomEvent('ta:shirt-nudge:goal', { detail: { goal: key, variation: state.variation } }));
  }

  // Fallback for when the Original/Control arm cannot run custom JS: read the bucket
  // straight from Convert. Variation names must contain "v1" / "v2"; anything else = control.
  function detectVariationFromConvert() {
    if (!cfg.experimentId) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (state.variation || tries > 40) {
        clearInterval(timer);
        return;
      }
      var data = window.convert && window.convert.currentData;
      var exp = data && data.experiments && data.experiments[cfg.experimentId];
      if (!exp || tries < 10) return; // give the variation JS ~1s to report first
      var name = String(exp.variation_name || (exp.variation && exp.variation.name) || '').toLowerCase();
      setVariation(/v2/.test(name) ? 'v2' : /v1/.test(name) ? 'v1' : 'control');
      clearInterval(timer);
    }, 100);
  }

  /* ---------- variation ---------- */

  function setVariation(variation, fromPreview) {
    variation = String(variation || '').toLowerCase();
    if (variation === 'original' || variation === 'off') variation = 'control';
    if (VARIATIONS.indexOf(variation) === -1) return;
    var qa = sessionGet(QA_KEY);
    if (qa && qa.variation && !fromPreview) return; // preview link wins over Convert
    state.variation = variation;
    log('variation', state.variation);
    update();
  }

  // Preview links (kept for the browser session, never sent to Convert):
  //   ?ta_nudge=v1 | v2 | off  — same values as window.AB_CART_NUDGE
  function readQaParams() {
    var forced = String(new URLSearchParams(location.search).get('ta_nudge') || '').toLowerCase();
    if (forced === 'off') sessionSet(QA_KEY, { variation: 'control' });
    else if (forced === 'v1' || forced === 'v2') sessionSet(QA_KEY, { variation: forced });
    var qa = sessionGet(QA_KEY);
    if (qa && qa.variation) setVariation(qa.variation, true);
  }

  function drainQueue() {
    var queue = window.taShirtNudgeQ || [];
    window.taShirtNudgeQ = {
      push: function (cmd) {
        if (cmd && cmd.variation) setVariation(cmd.variation);
      },
    };
    for (var i = 0; i < queue.length; i++) window.taShirtNudgeQ.push(queue[i]);
  }

  // Same values as the ?ta_nudge= preview links: 'v1' | 'v2' | 'off'.
  // A valid value is saved in sessionStorage, so the version stays on every page of this
  // tab until it is changed; closing the tab forgets it and the visitor sees the original.
  function applyDesign(value) {
    var v = String(value || '').toLowerCase();
    if (v === 'v1' || v === 'v2' || v === 'off') sessionSet(AB_KEY, v);
    setVariation(v);
  }

  // window.AB_CART_NUDGE = 'v1' from Convert works whether it runs before or after this script.
  // Setting it after load clears a saved ?ta_nudge= preview, so one line is enough in the console;
  // a ?ta_nudge= param in the current URL still wins.
  function watchAbGlobal() {
    var value = window.AB_CART_NUDGE;
    if (!value) value = sessionGet(AB_KEY); // version set on an earlier page of this tab
    try {
      Object.defineProperty(window, 'AB_CART_NUDGE', {
        configurable: true,
        get: function () { return value; },
        set: function (next) {
          value = next;
          if (!/[?&]ta_nudge=/.test(location.search)) sessionRemove(QA_KEY);
          applyDesign(next);
        },
      });
    } catch (e) { /* property locked; the initial value below still applies */ }
    if (value) applyDesign(value);
  }

  /* ---------- shirt identification ---------- */

  var idsPromise = null;

  function loadShirtIds() {
    if (idsPromise) return idsPromise;
    var cacheKey = collections.join(',');
    var cached = sessionGet(IDS_KEY);
    if (cached && cached.key === cacheKey && Date.now() - cached.at < IDS_TTL) {
      cached.ids.forEach(function (id) { shirtIds[id] = true; });
      idsPromise = Promise.resolve();
      return idsPromise;
    }

    function fetchCollection(handle, page, acc) {
      var url = ROOT + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
      return nativeFetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (json) {
          var products = json.products || [];
          products.forEach(function (p) { acc.push(String(p.id)); });
          return products.length === 250 ? fetchCollection(handle, page + 1, acc) : acc;
        });
    }

    idsPromise = Promise.all(collections.map(function (h) { return fetchCollection(h, 1, []); }))
      .then(function (lists) {
        var all = [].concat.apply([], lists);
        all.forEach(function (id) { shirtIds[id] = true; });
        sessionSet(IDS_KEY, { key: cacheKey, at: Date.now(), ids: Object.keys(shirtIds) });
      })
      .catch(function (err) {
        idsPromise = null; // retry on the next cart change
        log('collection fetch failed', err);
      });
    return idsPromise;
  }

  function countShirts(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return shirtIds[String(item.product_id)] ? sum + item.quantity : sum;
    }, 0);
  }

  /* ---------- cart tracking ---------- */

  var nativeFetch = window.fetch.bind(window);
  var refetchTimer = null;

  function isDrawerOpen() {
    var drawers = document.querySelectorAll(DRAWER_SELECTOR);
    for (var i = 0; i < drawers.length; i++) {
      if (drawers[i].classList.contains(DRAWER_OPEN_CLASS)) return true;
    }
    return false;
  }

  function onMutationStart() {
    if (isDrawerOpen()) state.addedWhileOpen = true;
  }

  function scheduleCartFetch() {
    clearTimeout(refetchTimer);
    refetchTimer = setTimeout(function () {
      nativeFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(handleCart)
        .catch(function (err) { log('cart fetch failed', err); });
    }, 150);
  }

  function handleCart(cart) {
    if (!cart || !cart.items) return;
    loadShirtIds().then(function () {
      var previous = state.shirtCount;
      var count = countShirts(cart);
      state.cart = cart;
      state.itemCount = cart.item_count || 0;
      state.shirtCount = count;

      if (previous !== null && count > previous && state.addedWhileOpen && state.variation) {
        if (previous === 0) triggerGoal('added0', true);
        else if (previous < bundleQty) triggerGoal('added13', true);
      }
      state.addedWhileOpen = false;
      log('cart', { shirts: count, items: state.itemCount, previous: previous });
      update();
    });
  }

  function interceptNetwork() {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var mutation = CART_MUTATION.test(url);
      if (mutation) onMutationStart();
      var request = nativeFetch.apply(window, arguments);
      if (mutation) request.then(scheduleCartFetch, function () {});
      return request;
    };

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._taNudgeMutation = CART_MUTATION.test(String(url));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this._taNudgeMutation) {
        onMutationStart();
        this.addEventListener('loadend', scheduleCartFetch);
      }
      return send.apply(this, arguments);
    };
  }

  // The theme redraws the drawer via the global refreshCart(cart) (assets/app.js.liquid).
  function wrapRefreshCart() {
    if (typeof window.refreshCart !== 'function' || window.refreshCart._taNudge) return;
    var original = window.refreshCart;
    window.refreshCart = function (cart) {
      var result = original.apply(this, arguments);
      handleCart(cart);
      return result;
    };
    window.refreshCart._taNudge = true;
  }

  /* ---------- drawer open → activation ---------- */

  function onDrawerOpen() {
    log('drawer open');
    activateExperiment();
    if (state.cart) update();
    else scheduleCartFetch();
  }

  function watchDrawer() {
    var wasOpen = isDrawerOpen();
    var observer = new MutationObserver(function () {
      var nowOpen = isDrawerOpen();
      if (nowOpen && !wasOpen) onDrawerOpen();
      wasOpen = nowOpen;
    });
    document.querySelectorAll(DRAWER_SELECTOR).forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    if (wasOpen) onDrawerOpen();
  }

  function watchCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(
        DRAWER_SELECTOR + ' .cart-footer__cta button, ' + DRAWER_SELECTOR + ' [name="checkout"]'
      );
      if (btn && state.variation) triggerGoal('checkout', false);
    }, true);
  }

  /* ---------- rendering ---------- */

  // Amounts are set in the shop currency (GBP). Convert them with the theme's currency
  // switcher (window.Currency), like the cart prices, so a shopper viewing ₹ sees ₹.
  function displayCurrency() {
    return (window.Currency && window.Currency.currentCurrency) || '';
  }

  function formatMoney(amount) {
    var cents = Math.round(amount * 100);
    var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var C = window.Currency;
    var current = displayCurrency();
    if (C && typeof C.convert === 'function' && typeof C.formatMoney === 'function' && current && current !== shopCurrency) {
      var formats = C.moneyFormats && C.moneyFormats[current];
      var format = formats && (formats.money_format || formats.money_with_currency_format);
      if (format) {
        var converted = Math.round(C.convert(cents, shopCurrency, current) / 100) * 100;
        return C.formatMoney(converted, format).replace(/<[^>]*>/g, '').replace(/[.,]00(?=\D*$)/, '').trim();
      }
    }
    var whole = Math.round(amount);
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: shopCurrency, maximumFractionDigits: 0 }).format(whole);
    } catch (e) {
      return '£' + whole;
    }
  }

  var icons = cfg.icons || {};

  function iconImg(src, size, extraClass) {
    return src
      ? '<img class="ta-sn__icon' + (extraClass ? ' ' + extraClass : '') + '" src="' + src + '" width="' + size + '" height="' + size + '" alt="" aria-hidden="true">'
      : '';
  }

  // 1-3 shirts (v1 + v2): Figma "V2" strip. 0 shirts (v2 only): Figma reminder (node 15:522).
  function buildHtml(count) {
    var price = formatMoney(cfg.price);
    var saving = formatMoney(cfg.saving);
    if (count === 0) {
      var perShirt = formatMoney(cfg.price / bundleQty);
      return '<span class="ta-sn__circle">' + iconImg(icons.reminderShirt, 13.333) + '</span>' +
        '<span class="ta-sn__text">Shirt offer: ' + bundleQty + ' for ' + price + ', only ' + perShirt + ' per shirt. ' +
        '<strong class="ta-sn__save">Save ' + saving + '</strong></span>' +
        iconImg(icons.arrow, 16, 'ta-sn__arrow');
    }
    var remaining = bundleQty - count;
    return iconImg(icons.dark, 14) +
      '<span class="ta-sn__text">Add <strong>' + remaining + ' more</strong> ' + (remaining === 1 ? 'shirt' : 'shirts') + ' to unlock ' + bundleQty + ' shirts for ' + price + ' and save ' + saving + '</span>';
  }

  function cartState() {
    if (state.shirtCount === null || state.itemCount === 0) return null;
    if (state.shirtCount === 0) return '0';
    return state.shirtCount < bundleQty ? '1-3' : '4+';
  }

  // Data attributes on every nudge, for click/heatmap/Convert targeting:
  //   data-ta-nudge-design = v1 | v2 (same values as window.AB_CART_NUDGE)
  //   data-ta-nudge-type   = nudge (1-3 shirts) | reminder (0 shirts)
  //   data-ta-nudge-state  = 0 | 1-3,  data-ta-nudge-shirts = current shirt count
  function setNudgeData(el) {
    el.setAttribute('data-ta-nudge-design', state.variation);
    el.setAttribute('data-ta-nudge-type', state.shirtCount === 0 ? 'reminder' : 'nudge');
    el.setAttribute('data-ta-nudge-state', state.shirtCount === 0 ? '0' : '1-3');
    el.setAttribute('data-ta-nudge-shirts', String(state.shirtCount));
  }

  // Placed right after <ul class="subtotlalist subtotlalist_top"> (the subtotal, a sibling of
  // ul.cart_items), falling back to right after ul.cart_items. The reminder becomes a link
  // when "Reminder link" is set in theme settings.
  function nudgeAnchor(list) {
    var subtotal = list.parentNode.querySelector(':scope > ul.subtotlalist_top');
    return subtotal || list;
  }

  function removeNudge(list) {
    list.parentNode.querySelectorAll(':scope > .ta-sn-after').forEach(function (n) { n.remove(); });
  }

  function placeNudge(list, html) {
    var reminder = state.shirtCount === 0;
    var tag = reminder && cfg.reminderUrl ? 'a' : 'div';
    var row = document.createElement('div');
    row.className = 'ta-sn-after';
    row.innerHTML = '<' + tag + ' class="ta-sn ' + (reminder ? 'ta-sn--reminder' : 'ta-sn--nudge') + '"' +
      (tag === 'a' ? ' href="' + cfg.reminderUrl + '"' : '') + '>' + html + '</' + tag + '>';
    setNudgeData(row.firstChild);
    var anchor = nudgeAnchor(list);
    anchor.parentNode.insertBefore(row, anchor.nextSibling);
  }

  var lastSignature = null;

  function render(force) {
    var cartBucket = cartState();
    var v = state.variation;
    // var show = !!v && ((cartBucket === '1-3' && v !== 'control') || (cartBucket === '0' && v === 'v1'));
    var show = !!v && ((cartBucket === '1-3' && v !== 'control') || (cartBucket === '0' && v === 'v2'));
    var lists = document.querySelectorAll(DRAWER_SELECTOR + ' ul.js-cart_items');
    var signature = [show, v, state.shirtCount, state.cart && state.cart.token, state.itemCount, displayCurrency()].join('|');

    // Skip when nothing changed and our nodes are still in place (the theme rebuilds the list on every change).
    var inPlace = !show || document.querySelector(DRAWER_SELECTOR + ' .ta-sn');
    if (!force && signature === lastSignature && inPlace) return;
    lastSignature = signature;

    // <html data-ta-nudge-design="v1 | v2 | off">: the visitor's version (same values as
    // window.AB_CART_NUDGE), set as soon as the variation is known, whatever the cart holds.
    if (v) document.documentElement.setAttribute('data-ta-nudge-design', v === 'control' ? 'off' : v);
    else document.documentElement.removeAttribute('data-ta-nudge-design');

    observeLists(false);
    lists.forEach(function (list) {
      removeNudge(list);
      // Test group (control / v1 / v2, not the design) and cart state (0 / 1-3 / 4+), set in every arm.
      list.removeAttribute('data-ta-nudge');
      list.setAttribute('data-ta-nudge-group', v || '');
      list.setAttribute('data-ta-nudge-state', cartBucket || '');
      if (show) placeNudge(list, buildHtml(state.shirtCount));
    });
    observeLists(true);
  }

  // Re-place the nudge whenever the theme re-renders the cart lines.
  var listObserver = new MutationObserver(function () { render(false); });
  function observeLists(on) {
    if (!on) {
      listObserver.disconnect();
      return;
    }
    document.querySelectorAll(DRAWER_SELECTOR + ' ul.js-cart_items').forEach(function (list) {
      listObserver.observe(list, { childList: true });
    });
  }

  function update() {
    render(true);

    // "Shown" goals — fired in every arm (shown13: real in V1/V2, "would have shown" in Control;
    // shown0: real in V2, "would have shown" in Control/V1).
    var cartBucket = cartState();
    if (state.variation && isDrawerOpen()) {
      if (cartBucket === '0') triggerGoal('shown0', true);
      else if (cartBucket === '1-3') triggerGoal('shown13', true);
    }
  }

  /* ---------- init ---------- */

  window.TAShirtNudge = {
    loaded: true,
    setVariation: setVariation,
    getState: function () { return JSON.parse(JSON.stringify(state)); },
  };

  interceptNetwork();
  drainQueue();
  watchAbGlobal();
  readQaParams();
  if (collections.length) loadShirtIds();

  function init() {
    wrapRefreshCart();
    observeLists(true);
    watchDrawer();
    // The theme's currency switcher loads late and can change at any time; redraw amounts when it does.
    var lastCurrency = displayCurrency();
    setInterval(function () {
      var current = displayCurrency();
      if (current !== lastCurrency) {
        lastCurrency = current;
        render(true);
      }
    }, 1000);
    watchCheckout();
    // app.js may define refreshCart after us; retry once everything has loaded.
    window.addEventListener('load', wrapRefreshCart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
